import { AccessPath } from "@intentsify/authorization";
import { DisplayCampaignMonitoringScreen } from "types";
import { createScreen } from "utils/createScreen";

export const DISPLAY_CAMPAIGN_MONITORING_ACCESS_PATH =
  "campaign.displayMonitoring" as AccessPath;

export const DisplayCampaignMonitoringScreenDefinition = {
  ...createScreen({
    name: DisplayCampaignMonitoringScreen,
    path: "/dashboard/display-campaign-monitoring",
    routePath: ["/display-campaign-monitoring"],
  }),
  accessPath: DISPLAY_CAMPAIGN_MONITORING_ACCESS_PATH,
};
